export const actions = {
    CORE_NOTIFICATION: 'CORE:NOTIFICATION',
    CORE_REQUEST: 'CORE_REQUEST',
    SET_SPINNER: 'SET_SPINNER',
    SET_ACTIVITYTYPE_WITHMODAL: 'SET_ACTIVITYTYPE_WITHMODAL'
};
